import * as React from "react"

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../ui/select.jsx";

export function SelectCommunityStatus({ ...props }) {
  return (
    <Select {...props}>
      <SelectTrigger>
        <SelectValue placeholder="Select a status" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="deactived">Deactivated</SelectItem>
          <SelectItem value="onboarding">Onboarding</SelectItem>
          <SelectItem value="secret-shopper">Secret Shopper</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
